module.exports = __webpack_public_path__ + "static/hassle-free-4820b86fc261cb919aec52fd63557dbf.svg";